import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, Route, Switch} from 'react-router-dom';

import JournalFacet from "../../../components/journal/admin/list/facet";
import JournalSearch from "../../../components/journal/admin/list/search";
import JournalItem from "../../../components/journal/admin/list/item";
import {bindActionCreators} from "redux";
import * as Actions from "../../../store/modules/journals";
import {PropTypes} from "prop-types";
import * as func from "../../../utils/functions";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH} from "../../../wpconfig";
import FrontFooter from '../../../components/etc/footer/';

class Journals extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'admin/journals',
			url: 'wp-admin/admin.php?page=journal&',
		}
	}

	componentDidMount() {
		if (location.search.substring(1)) {
			this.props.dataActions.setJournals({'param': func.parseParams(location.search.substring(1))});
		}
		// 이해 안됨.
		setTimeout(() => {
			this.getList();
		}, 0);
	}

	getList() {
		console.log(this.props.param)
		func.getData(this.state.action, this.props.param).then((response) => {
			this.setState({
				isInit: true,
			})
			this.props.dataActions.setJournals(response);
		});
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.props.param;
		param['current_page'] = paged;

		const {dataActions} = this.props;
		dataActions.setJournals({"param": param});

		func.getData(this.state.action, param).then((response) => {
			this.props.dataActions.setJournals(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	order = (key) => {
		let param = this.props.param;
		if(param.order_by === key) {
			if (param.order === 'asc')
				param.order = 'desc'
			else
				param.order = 'asc'
		} else {
			param.order_by = key
			param.order = 'desc'
		}

		const {dataActions} = this.props;
		dataActions.setJournals({"param": param});

		func.getData(this.state.action, param).then((response) => {
			this.props.dataActions.setJournals(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	onRecordCheck = () => {
		const checkedRecords = this.props.checkedRecords;
		if (event.target.checked) {
			checkedRecords.push(event.target.value)
			this.props.dataActions.setJournals({checkedRecords : checkedRecords});
		} else {
			const idx = checkedRecords.indexOf(event.target.value)
			if (idx > -1) checkedRecords.splice(idx, 1)
			this.props.dataActions.setJournals({checkedRecords : checkedRecords});
		}
		this.forceUpdate()
	}

	compareArray = function(a, b){
		if(JSON.stringify(a) === JSON.stringify(b)) {
			return true;
		} else{ return false; }
	}

	isAllChecked () {
		let recordsId = [];
		this.props.records.map((record, index) => {
			recordsId.push(record.journal_id)
		})
		let checkedRecordsId = this.props.checkedRecords;

		let nameSort = function(a,b){
			if(a < b){
				return -1
			}else if(a > b){
				return 1;
			}else{
				return 0;
			}
		}

		recordsId.sort(nameSort);
		checkedRecordsId.sort(nameSort);

		return this.compareArray(recordsId, checkedRecordsId)
	}

	onAllRecordCheck = () => {
		const checkedRecords = [];
		if (event.target.checked) {
			{this.props.records.map((record, index) => {
				checkedRecords.push(record.journal_id)
			})}
		}
		this.props.dataActions.setJournals({checkedRecords : checkedRecords});
		this.forceUpdate()
	}

	render() {
		const {records, param} = this.props;
		const {isInit} = this.state;

		const allChecked = this.isAllChecked()
		return (
			<div className="container-fluid mt-3 admin-layout">
				<div className="row">
					<div className="admin-sidebar">
						<JournalFacet/>
					</div>
					<div className="col admin-contents">

						<JournalSearch/>

						<table className="table table-striped table-thin border-bottom journal-list">
							<thead>
							<tr>
								<th scope="col">
									<input type="checkbox" className="ml-0"
									       checked={allChecked}
									       onChange={this.onAllRecordCheck} />
								</th>
								<th scope="col">NO</th>
								<th scope="col">ID</th>
								<th scope="col" className={"order" + (param.order_by === 'title' ? ' active' : '')} onClick={() => this.order('title')}>
									저널명
									{param.order_by ==='title' && param.order ==='asc'?<span>▲</span>:<span>▼</span>}
								</th>
								<th scope="col" className={"order" + (param.order_by === 'issn' ? ' active' : '')} onClick={() => this.order('issn')}>
									ISSN
									{param.order_by ==='issn' && param.order ==='asc'?<span>▲</span>:<span>▼</span>}
								</th>
								<th scope="col">발행국</th>
								<th scope="col" className="pl-0 pr-0 ml-0 mr-0">
									<span className="btn btn-outline-dark db-check-title">SE</span>
									<span className="btn btn-outline-dark db-check-title">SS</span>
									<span className="btn btn-outline-dark db-check-title">AH</span>
									<span className="btn btn-outline-dark db-check-title">ES</span>
									<span className="btn btn-outline-dark db-check-title">SP</span>
									<span className="btn btn-outline-dark db-check-title">NA</span>
									<span className="btn btn-outline-dark db-check-title">KC</span>
									<span className="btn btn-outline-dark db-check-title">KG</span>
									<span className="btn btn-outline-dark db-check-title">KD</span>
								</th>
								<th scope="col">상태</th>
								<th scope="col" className={"order" + (param.order_by === 'date' ? ' active' : '')} onClick={() => this.order('date')}>
									입력일
									{param.order_by ==='date' && param.order ==='asc'?<span>▲</span>:<span>▼</span>}
								</th>
								<th scope="col">수정일</th>
							</tr>
							</thead>
							<tbody>
							{!isInit && records.length <= 0 && <tr>
								<td colSpan={16}>로딩중입니다.</td>
							</tr>}
							{isInit && records.length <= 0 && <tr>
								<td colSpan={16}>결과가 없습니다.</td>
							</tr>}
							{records.map((record, index) => {
								const no = this.props.totalRecords - ((this.props.param.current_page - 1) * this.props.param.record_per_page) - index;
								const checked = this.props.checkedRecords.includes(record.journal_id)
								return (
									<JournalItem key={index} record={record} no={no}
									             onRecordCheck={this.onRecordCheck}
									             checked={checked}/>
								)
							})}
							</tbody>
						</table>
						{this.props.totalPage > 1 &&
						<div className="mt-4">
							<div>
								<div className="paging-wrap">
									<ReactPaginate
										forcePage={Number(this.props.param.current_page) - 1}
										pageCount={this.props.totalPage}
										marginPagesDisplayed={2}
										pageRangeDisplayed={2}
										onPageChange={this.handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										pageClassName={'page-item'}
										pageLinkClassName={'page-link'}
										previousClassName={'page-item page-item-prev'}
										previousLinkClassName={'page-link'}
										nextClassName={'page-item page-item-next'}
										nextLinkClassName={'page-link'}
									/>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
				<FrontFooter
					param={this.props.param}
					facet={this.props.facet}
					dataActions={this.props.dataActions} />
			</div>
		)
	}
}

export default connect(
	(state) => ({
		param: state.journals.param ? state.journals.param : {},
		records: state.journals.records ? state.journals.records : [],
		checkedRecords : state.journals.checkedRecords ? state.journals.checkedRecords : [],
		facet: state.journals.facet ? state.journals.facet : {},
		totalRecords: state.journals.totalRecords ? state.journals.totalRecords : 0,
		totalPage: state.journals.totalPage ? state.journals.totalPage : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Journals)

Journals.propTypes = {
	// args: PropTypes.object,
	// records: PropTypes.array,
	// facet: PropTypes.object,
	// totalRecords: PropTypes.number,
	// totalPage: PropTypes.number,
};
